import { render, staticRenderFns } from "./Comp2t3.vue?vue&type=template&id=567e0abe&scoped=true&"
import script from "./Comp2t3.vue?vue&type=script&lang=js&"
export * from "./Comp2t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp2t3.vue?vue&type=style&index=0&id=567e0abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e0abe",
  null
  
)

export default component.exports